import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class FowlInSlotBonusDecision extends Decision {
    public evaluate(): Exit {
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();

        if (record instanceof SpinRecord) {
            return Exit.True;
        } else {
            return Exit.False;
        }
    }

}
